export const translations = {
  en: {
    // Header
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    logout: 'Logout',
    login: 'Log in',
    user: 'User',

    // Auth
    brandingTitle: 'Welcome to FX-Pool',
    brandingSubtitle: 'Your trusted partner in cryptocurrency mining. Fast, secure, and profitable.',
    logIn: 'Log In',
    welcomeBack: 'Welcome back! Please enter your details.',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    or: 'OR',
    signInWithGoogle: 'Sign in with Google',
    dontHaveAccount: "Don't have an account?",
    signUp: 'Sign up',
    createAccountSubtitle: 'Start your mining journey with us.',
    yourDetails: 'Your details',
    verifyEmail: 'Verify email',
    setPassword: 'Set password',
    back: 'Back',
    creatingAccount: 'Creating Account...',
    createAccount: 'Create Account',
    resendIn: 'Resend in {seconds}s',
    resendOtp: 'Resend OTP',
    didntReceive: "Didn't receive the code?",
    enterOtpPlaceholder: 'Enter OTP',
    sentVerification: 'We sent a verification code to',
    enter6Digit: 'Please enter the 6-digit code.',
    createYourPassword: 'Create your password',
    chooseStrong: 'Choose a strong password for your account.',
    confirmPassword: 'Confirm Password',
    enterPassword: 'Enter your password',
    stepOf: 'Step {step} of 3',
    processing: 'Processing...',
    verifying: 'Verifying...',
    iAcceptThe: 'I accept the',
    termsOfUse: 'Terms of Use',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    alreadyHaveAccount: 'Already have an account?',
    continueWithGoogle: 'Continue with Google',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 6 characters',
    otp: 'OTP',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    previous: 'Previous',
    next: 'Next',
    submit: 'Submit',
    page: 'Page',
    continue: 'Continue',
    send: 'Send',
    close: 'Close',
    open: 'Open',
    
    // Dashboard
    dashboard: 'Dashboard',
    account: 'Account',
    balance: 'Balance',
    total: 'Total',
    myAccount: 'My Account',
    totalBalance: 'Total Balance',
    totalMiningPower: 'Total Mining Power',
    activate: 'Activate',
    miningPower: 'Mining Power',
    tryBestPerformance: 'Try Best Performance Before Buying!',
    getMiningExperience: 'Get 1 day BTC mining real experience without investment!',
    oneDayMining: '1-day Mining',
    forFree: 'for free',
    nothingYet: 'Nothing yet? Get our exclusive promos for easy start!',
    totalMiningReward: 'Total Mining Reward',
    wantSpecialDeal: 'Want a special deal? Contact your manager.',
    miningAllocationsAndRewards: 'Your mining allocations and rewards',
    miningAnalytics: 'Mining Analytics',
    realTimePerformanceMetrics: 'Real-time performance metrics and insights',
    hashrate: 'Hashrate',
    uptime: 'Uptime',
    temperature: 'Temperature',
    quickActions: 'Quick Actions',
    rentAsics: 'Rent ASICs',
    buyAsics: 'Buy ASICs',
    startEarningToday: 'Start Earning Today',
    earnUpTo: 'Earn up to',
    withWeeklyCompoundRewards: 'with weekly compound rewards',
    weeklyCompound: 'Weekly compound',
    secureMining: 'Secure Mining',
    btcMiningProducts: 'BTC Mining Products',
    from: 'From',
    getSpecialOffer: 'Get a SPECIAL offer',
    overview: 'Overview',
    activeContracts: 'Active Contracts',
    buyContract: 'Buy Contract',
    addMore: 'Add more',
    dailyGains: 'Daily Gains',
    listOfContracts: 'List of Contracts',
    contract: 'Contract',
    tariff: 'Tariff',
    totalGains: 'Total Gains',
    type: 'Type',
    daysLeft: 'Days Left',
    status: 'Status',
    inOneMonth: 'in one month',
    chartPlaceholder: 'Chart will be displayed here',
    
    // Rented ASICs
    myRentedMiningFarm: 'My Rented Mining Farm',
    asicsRented: 'ASICs Rented',
    asics: 'ASICs',
    dailyRevenue: 'Daily Revenue',
    deviceId: 'Device ID',
    rentedAsicModelTH: 'Rented ASIC Model, TH',
    yesterdayProfit: 'Yesterday profit',
    totalMinedBtc: 'Total Mined BTC',
    hostingFeePaymentSchedule: 'Hosting Fee Payment Schedule',
    hostingFeeAmount: 'Hosting Fee Amount',
    hostingFeeStatus: 'Hosting Fee Status',
    noRentedAsics: 'No rented ASICs yet',
    
    // Purchased ASICs
    addAsics: 'Add ASICs',
    miningOutput: 'Mining Output',
    myAsics: 'My ASICs',
    latestHashrate: 'Latest hashrate',
    hostingPaymentDate: 'Hosting payment date',
    actions: 'Actions',
    noPurchasedAsics: 'No purchased ASICs yet',
    model: 'Model',
    
    // My Pool
    ecosPool: 'FX-Pool',
    hashrateTooltip: 'This is the average hashrate for one day',
    totalEarningsTooltip: 'This is the total profit in bitcoins for all time',
    efficiencyTooltip: 'This is the difference between the accepted hash rate and the rejected hash rate',
    connectedAsicsTooltip: 'These are your ASICs connected to the pool',
    minersList: 'Miners List',
    miner: 'Miner',
    accepted: 'Accepted',
    rejected: 'Rejected',
    earnings: 'Earnings',
    noDataToDisplay: 'No data to display',
    minersNotConnected: 'Miners not connected',
    minersNotConnectedText: 'After setting up and connecting your ASIC devices, they will appear in this list',
    configurePoolParameters: 'Configure pool parameters in your ASIC',
    configurePoolParametersDescription: 'Log in to your ASIC device\'s web interface and specify the following parameters:',
    poolUrl: 'Pool URL',
    yourUserId: 'Your User ID',
    workerName: 'Worker Name',
    workerNameDescription: 'Set the Worker Name yourself in the ASIC settings',
    workerNameTooltip: 'The Worker Name format is: 908029.asic_S21_245_hero\n\nExample: 908029.asic_S21_245_hero\n\nStep 1: Enter your User ID (shown above)\nStep 2: Add a dot (.)\nStep 3: Enter your chosen Worker Name (e.g., asic_S21_245_hero)\n\nThe system will automatically recognize your device using this format.',
    workerNameNote: 'Important: userID (your login) is automatically added to the workername',
    saveSettingsAndRestart: 'Save settings and restart device',
    saveSettingsAndRestartDescription: 'After entering the parameters, save the changes and restart your ASIC device.',
    waitForConnection: 'Wait for connection',
    waitForConnectionDescription: 'After restarting, the system will automatically identify the hashrate from your devices. They will appear in the miners list within a few minutes.',
    format: 'Format',
    connectedAsics: 'Connected ASICs',
    totalEarnings: 'Total Earnings',
    
    // Sidebar
    home: 'Home',
    myDashboards: 'My Dashboards',
    mainDashboard: 'Main dashboard',
    rentedAsics: 'Rented ASICs',
    purchasedAsics: 'Purchased ASICs',
    new: 'NEW',
    btcMiningStore: 'BTC Mining Store',
    marketplace: 'Marketplace',
    settings: 'Settings',
    generalSettings: 'General Settings',
    transactions: 'Transactions',
    withdrawals: 'Withdrawals',
    support: 'Support',
    
    // Registration
    enterYourDetails: 'Enter your details to create your account',
    acceptTerms: 'I accept the Terms and Conditions',
    termsRequired: 'You must accept the terms and conditions',
    enterOtp: 'Enter the 6-digit code sent to your email',
    otpCode: 'OTP Code',
    resendCode: 'Resend Code',
    createPassword: 'Create a secure password for your account',
    passwordMustContain: 'Password must contain at least 8 characters, 1 uppercase, 1 lowercase, and 1 number',
    passwordsDoNotMatch: 'Passwords do not match',
    
    // Settings
    changeEmail: 'Change Email',
    changePhone: 'Change Phone',
    firstName: 'First name',
    lastName: 'Last name',
    saveChanges: 'Save changes',
    verify: 'Verify',
    verified: 'Verified',
    notVerified: 'Not Verified',
    promocode: 'Promocode',
    activityHistory: 'Activity History',
    twoFASettings: '2FA Settings',
    changePassword: 'Change Password',
    
    // Withdraw
    withdrawFunds: 'Withdraw Funds',
    withdrawYourEarnings: 'Withdraw your earnings securely',
    method: 'Method',
    details: 'Details',
    
    // Transactions
    transactionHistory: 'Transaction History',
    externalKey: 'External key',
    description: 'Description',
    amount: 'Amount',
    dateTime: 'Date/Time',
    comment: 'Comment',
    uploadToEmail: 'Upload all to email',
    
    // Marketplace
    popularPicks: 'Popular Picks',
    frequentlyAskedQuestions: 'Frequently Asked Questions',
    howItWorks: 'How Hosted ASICs Marketplace Works',
    
    // Chat
    chat: 'Chat',
    typeMessage: 'Type your message...',
    sendMessage: 'Send',
    hello: 'Hello',
    
    // Common errors/validation
    required: 'Required',
    invalid: 'Invalid',
  },
  ru: {
    // Header
    deposit: 'Пополнить',
    withdraw: 'Вывести',
    logout: 'Выйти',
    login: 'Войти',
    user: 'Пользователь',
    
    // Common
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    search: 'Поиск',
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успешно',
    confirm: 'Подтвердить',
    back: 'Назад',
    previous: 'Предыдущий',
    next: 'Далее',
    submit: 'Отправить',
    continue: 'Продолжить',
    page: 'Страница',
    send: 'Отправить',
    close: 'Закрыть',
    open: 'Открыть',
    
    // Dashboard
    dashboard: 'Панель управления',
    account: 'Счет',
    balance: 'Баланс',
    total: 'Всего',
    myAccount: 'Мой аккаунт',
    totalBalance: 'Общий баланс',
    totalMiningPower: 'Общая мощность майнинга',
    activate: 'Активировать',
    miningPower: 'Мощность майнинга',
    tryBestPerformance: 'Попробуйте лучшую производительность перед покупкой!',
    getMiningExperience: 'Получите реальный опыт майнинга BTC на 1 день без инвестиций!',
    oneDayMining: 'Майнинг на 1 день',
    forFree: 'бесплатно',
    nothingYet: 'Пока ничего нет? Получите наши эксклюзивные промо для легкого старта!',
    totalMiningReward: 'Общая награда за майнинг',
    wantSpecialDeal: 'Хотите особую сделку? Свяжитесь с вашим менеджером.',
    miningAllocationsAndRewards: 'Ваши распределения майнинга и награды',
    miningAnalytics: 'Аналитика майнинга',
    realTimePerformanceMetrics: 'Метрики производительности в реальном времени',
    hashrate: 'Хешрейт',
    uptime: 'Время работы',
    efficiency: 'Эффективность',
    temperature: 'Температура',
    quickActions: 'Быстрые действия',
    rentAsics: 'Арендовать ASIC',
    buyAsics: 'Купить ASIC',
    startEarningToday: 'Начните зарабатывать сегодня',
    earnUpTo: 'Зарабатывайте до',
    withWeeklyCompoundRewards: 'с еженедельными сложными наградами',
    weeklyCompound: 'Еженедельное начисление',
    secureMining: 'Безопасный майнинг',
    btcMiningProducts: 'Продукты майнинга BTC',
    from: 'От',
    getSpecialOffer: 'Получить специальное предложение',
    overview: 'Обзор',
    activeContracts: 'Активные контракты',
    buyContract: 'Купить контракт',
    addMore: 'Добавить еще',
    dailyGains: 'Ежедневные доходы',
    listOfContracts: 'Список контрактов',
    contract: 'Контракт',
    tariff: 'Тариф',
    totalGains: 'Общий доход',
    type: 'Тип',
    daysLeft: 'Дней осталось',
    status: 'Статус',
    inOneMonth: 'за один месяц',
    chartPlaceholder: 'График будет отображаться здесь',
    
    // Rented ASICs
    myRentedMiningFarm: 'Моя арендованная майнинг-ферма',
    asicsRented: 'Арендованные ASIC',
    asics: 'ASIC',
    dailyRevenue: 'Ежедневный доход',
    deviceId: 'ID устройства',
    rentedAsicModelTH: 'Модель арендованного ASIC, TH',
    yesterdayProfit: 'Вчерашняя прибыль',
    totalMinedBtc: 'Всего добыто BTC',
    hostingFeePaymentSchedule: 'График оплаты платы за хостинг',
    hostingFeeAmount: 'Сумма платы за хостинг',
    hostingFeeStatus: 'Статус платы за хостинг',
    noRentedAsics: 'Пока нет арендованных ASIC',
    
    // Purchased ASICs
    addAsics: 'Добавить ASIC',
    miningOutput: 'Выход майнинга',
    myAsics: 'Мои ASIC',
    latestHashrate: 'Последний хешрейт',
    hostingPaymentDate: 'Дата оплаты хостинга',
    actions: 'Действия',
    noPurchasedAsics: 'Пока нет купленных ASIC',
    model: 'Модель',
    
    // My Pool
    ecosPool: 'FX-Pool',
    hashrateTooltip: 'Это средний хешрейт за один день',
    totalEarningsTooltip: 'Это общая прибыль в биткоинах за все время',
    efficiencyTooltip: 'Это разница между принятым хешрейтом и отклоненным хешрейтом',
    connectedAsicsTooltip: 'Это ваши ASIC, подключенные к пулу',
    minersList: 'Список майнеров',
    miner: 'Майнер',
    accepted: 'Принято',
    rejected: 'Отклонено',
    earnings: 'Заработок',
    noDataToDisplay: 'Нет данных для отображения',
    minersNotConnected: 'Майнеры не подключены',
    minersNotConnectedText: 'После настройки и подключения ваших ASIC-устройств они появятся в этом списке',
    configurePoolParameters: 'Настройте параметры пула в вашем ASIC',
    configurePoolParametersDescription: 'Войдите в веб-интерфейс вашего ASIC-устройства и укажите следующие параметры:',
    poolUrl: 'URL пула',
    yourUserId: 'Ваш ID пользователя',
    workerName: 'Имя воркера',
    workerNameDescription: 'Установите имя воркера самостоятельно в настройках ASIC',
    workerNameTooltip: 'Формат имени воркера: 908029.asic_S21_245_hero\n\nПример: 908029.asic_S21_245_hero\n\nШаг 1: Введите ваш ID пользователя (показан выше)\nШаг 2: Добавьте точку (.)\nШаг 3: Введите выбранное имя воркера (например, asic_S21_245_hero)\n\nСистема автоматически распознает ваше устройство, используя этот формат.',
    workerNameNote: 'Важно: userID (ваш логин) автоматически добавляется к имени воркера',
    saveSettingsAndRestart: 'Сохраните настройки и перезагрузите устройство',
    saveSettingsAndRestartDescription: 'После ввода параметров сохраните изменения и перезагрузите ваше ASIC-устройство.',
    waitForConnection: 'Дождитесь подключения',
    waitForConnectionDescription: 'После перезагрузки система автоматически определит хешрейт с ваших устройств. Они появятся в списке майнеров в течение нескольких минут.',
    format: 'Формат',
    connectedAsics: 'Подключенные ASIC',
    totalEarnings: 'Общий заработок',
    
    // Sidebar
    home: 'Главная',
    myDashboards: 'Мои панели',
    mainDashboard: 'Главная панель',
    rentedAsics: 'Арендованные ASIC',
    purchasedAsics: 'Купленные ASIC',
    new: 'НОВОЕ',
    btcMiningStore: 'Магазин майнинга BTC',
    marketplace: 'Маркетплейс',
    settings: 'Настройки',
    generalSettings: 'Общие настройки',
    transactions: 'Транзакции',
    withdrawals: 'Выводы',
    support: 'Поддержка',
    
    // Auth
    email: 'Электронная почта',
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    forgotPassword: 'Забыли пароль?',
    signUp: 'Зарегистрироваться',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    dontHaveAccount: 'Нет аккаунта?',
    welcomeBack: 'Добро пожаловать! Пожалуйста, введите ваши данные',
    logIn: 'Войти',
    continueWithGoogle: 'Продолжить с Google',
    emailRequired: 'Электронная почта обязательна',
    emailInvalid: 'Электронная почта недействительна',
    passwordRequired: 'Пароль обязателен',
    passwordMinLength: 'Пароль должен содержать не менее 6 символов',
    moreOptionsInApp: 'Больше возможностей в приложении!',
    downloadApp: 'Скачайте приложение FX-Pool и получите доступ ко всем инструментам инвестирования в криптовалюты.',
    
    // Registration
    createAccount: 'Создать аккаунт',
    enterYourDetails: 'Введите ваши данные для создания аккаунта',
    acceptTerms: 'Я принимаю Условия использования',
    termsRequired: 'Вы должны принять условия использования',
    verifyEmail: 'Подтвердить Email',
    enterOtp: 'Введите 6-значный код, отправленный на вашу почту',
    otpCode: 'Код OTP',
    resendCode: 'Отправить код повторно',
    setPassword: 'Установить пароль',
    createPassword: 'Создайте надежный пароль для вашего аккаунта',
    passwordMustContain: 'Пароль должен содержать не менее 8 символов, 1 заглавную букву, 1 строчную букву и 1 цифру',
    passwordsDoNotMatch: 'Пароли не совпадают',
    processing: 'Обработка...',
    stepOf: 'Шаг {step} из 3',
    sentVerification: 'Мы отправили код подтверждения на',
    enter6Digit: 'Пожалуйста, введите 6-значный код для продолжения',
    enterOtpPlaceholder: 'Введите OTP',
    didntReceive: 'Не получили код?',
    resendIn: 'Повторить через {seconds}с',
    resendOtp: 'Повторить OTP',
    verifying: 'Проверка...',
    createYourPassword: 'Создайте ваш пароль',
    chooseStrong: 'Выберите надежный пароль для защиты вашего аккаунта',
    enterPassword: 'Введите пароль',
    iAcceptThe: 'Я принимаю',
    termsOfUse: 'Условия использования',
    privacyPolicy: 'Политика конфиденциальности',
    and: 'и',
    creatingAccount: 'Создание аккаунта...',
    
    // Settings
    changeEmail: 'Изменить Email',
    changePhone: 'Изменить телефон',
    firstName: 'Имя',
    lastName: 'Фамилия',
    saveChanges: 'Сохранить изменения',
    verify: 'Подтвердить',
    verified: 'Подтверждено',
    notVerified: 'Не подтверждено',
    promocode: 'Промокод',
    activityHistory: 'История активности',
    twoFASettings: 'Настройки 2FA',
    changePassword: 'Изменить пароль',
    
    // Withdraw
    withdrawFunds: 'Вывести средства',
    withdrawYourEarnings: 'Вывести ваши доходы безопасно',
    method: 'Метод',
    details: 'Детали',
    
    // Transactions
    transactionHistory: 'История транзакций',
    externalKey: 'Внешний ключ',
    description: 'Описание',
    amount: 'Сумма',
    dateTime: 'Дата/Время',
    comment: 'Комментарий',
    uploadToEmail: 'Загрузить все на email',
    

    // Marketplace
    popularPicks: 'Популярные выборы',
    frequentlyAskedQuestions: 'Часто задаваемые вопросы',
    howItWorks: 'Как работает маркетплейс размещенных ASIC',
    
    // Chat
    chat: 'Чат',
    typeMessage: 'Введите ваше сообщение...',
    sendMessage: 'Отправить',
    hello: 'Привет',
    
    // Common errors/validation
    required: 'Обязательно',
    invalid: 'Недействительно',
  },
};

export const getTranslation = (key, lang = 'en') => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
